/**
 * Replace {placeholders} or {{placeholders}} in a template string.
 * • Accepts either single or double curly braces.
 * • Leaves the token in place if no param is provided (useful for spotting
 *   missing values in dev).
 */
export function templateReplace(
  template: string | undefined | null,
  params: Record<string, string | number>,
): string {
  const safe = template ?? "";
  return safe.replace(/\{\{\s*(\w+)\s*\}\}|\{\s*(\w+)\s*\}/g, (_m, k1, k2) => {
    const key = k1 ?? k2;
    return key in params ? String(params[key]) : `{${key}}`;
  });
}

/**
 * Convert a string into a URL‐friendly slug:
 *  - lowercase
 *  - non-alphanumerics → hyphens
 *  - trim leading/trailing hyphens
 */
export function slugify(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}
